import { createLocalStorageStateHook } from "use-local-storage-state";

const useCloudFlow = createLocalStorageStateHook<string | null>(
  "cloud-flow",
  null
);

export default useCloudFlow;
